@if (addCommentDialog) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full flex justify-center items-center">
      <div class="items-center justify-center rounded-[16px] bg-white p-3 absolute">
        <div class="w-[350px]">
          <div class="mb-2 font-bold">
            Add Comment
          </div>
          <div>
            <textarea type="text" placeholder="Enter comment" class="input w-full" [(ngModel)]="commentToAdd"></textarea>
          </div>
          <div class="flex justify-between mt-5">
            <outline-button [marginRight]="true" (click)="addCommentCancel()" text="Cancel" />
            <full-button text="Save" (click)="addCommentSave()" />
          </div>
        </div>
      </div>
    </div>
  </div>
}
<div class="flex flex-row items-center text-[11px] text-[#8B96A2] m-1">
  <button (click)="examList()" class="hover:bg-[#E5E8EB] py-[2px] px-[4px] rounded">
    Exam List
  </button>
  <mat-icon fontIcon="chevron_right"></mat-icon>
  <button (click)="examInstances()" class="hover:bg-[#E5E8EB] py-[2px] px-[4px] rounded">
    Exam Instances
  </button>
  <mat-icon fontIcon="chevron_right"></mat-icon>
  <div class="text-black border-[#2663FF] border rounded w-fit py-[2px] px-[4px]">
    Exam Instance Comments
  </div>
</div>
<div class="m-5">
  <div class="flex justify-between items-center">
    <div class="text-xl font-bold">
      Comments for {{examName}}
    </div>
    <clear-button [faIcon]="faPlus" (click)="openAddCommentDialog()" text="Add Comment" />
  </div>
  <div class="grid grid-cols-4 font-bold mt-5 mb-3">
    <div>
      Username
    </div>
    <div class="col-span-2">
      Comment
    </div>
    <div>
      Date
    </div>
  </div>
  <hr />
  @for (comment of instanceCommentsResponse; track comment; let i = $index) {
    <div [ngClass]="i % 2 === 0? 'grid grid-cols-4 mt-2 p-2 rounded-[8px]': 'grid grid-cols-4 mt-2 p-2 rounded-[8px] bg-gray-100'">
      <div>
        {{comment.username}}
      </div>
      <div class="col-span-2">
        {{comment.comment}}
      </div>
      <div>
        {{comment.createdate | date: 'short'}}
      </div>
    </div>
  }
  @if (instanceCommentsResponse.length === 0) {
    <div class="text-center mt-2">
      No Comments
    </div>
  }
</div>
